<div class="table-responsive">
  <table class="table table-striped">
    <!--<caption>
      <input id="select_all" [(ngModel)]="isAllChecked" (change)="selectAllCheckBox($event);" class="css-checkbox select-all" type="checkbox">
      <label for="select_all" class="css-label">Select All</label>
    </caption>-->
    <thead class="thead-dark">
      <tr>
        <ng-container *ngFor="let field of pageFields;">
          <th class="small" *ngIf="field.isSystemRefId === 1;"></th>

          <ng-container *ngIf="field.isSystemRefId === 0;">
            <ng-container *ngIf="inputParams.isSortEnabled">
              <th (click)="SortData(field.columnName, field.isSortable)" [ngClass]="[field.isSortable === 1 ? 'sort SORTASC' : '']">
                <span>{{ field.columnHeader }}</span>
                <span class="sort">
                  <i [ngClass]="[field.columnName === inputParams.sortColumn && inputParams.isAscendingSort ? 'fa fa-long-arrow-up' : field.columnName === inputParams.sortColumn && !inputParams.isAscendingSort ? 'fa fa-long-arrow-down' : '']"></i>
                </span>
              </th>
            </ng-container>
            <ng-container *ngIf="!inputParams.isSortEnabled">
              <th>
                <span>{{ field.columnHeader }}</span>
              </th>
            </ng-container>
          </ng-container>


        </ng-container>
        <th *ngFor="let key of inputParams.customfieldTranslationKeys;">{{ key | translate}}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let data of listOfData;">
        <tr class="List-Row alterColor">
          <ng-container *ngFor="let field of pageFields;">
            <ng-container *ngFor="let propertyName of properties;">
              <ng-container *ngIf="field.columnName.toLowerCase() === propertyName.toLowerCase();">
                <td *ngIf="field.isSystemRefId === 1;" class="small">
                  <ng-container *ngIf="isSingleSelection">
                    <input type="radio" name="radiogroup_{{RefId}}" [value]="data[RefId]" (change)="toggleRadioButton(data)">
                  </ng-container>
                  <ng-container *ngIf="isMultipleSelection">
                    <input type="checkbox" class="css-checkbox checkbox-user" (click)="toggleCheckBox(data, data.checked)" [(ngModel)]="data.checked" id="checkbox_{{data[RefId]}}" value="{{data[RefId]}}">
                    <label for="checkbox_{{data[RefId]}}" class="css-label"></label>
                  </ng-container>
                </td>
                <td *ngIf="field.isSystemRefId === 0 && field.columnName.search('HtmlLink') === -1" [innerHTML]='[field.columnType === "DATE" ? (data[propertyName] | date : "dd/MM/yyyy") : data[propertyName]]'></td>
                <td *ngIf="field.isSystemRefId === 0 && field.columnName.search('HtmlLink') !== -1" clickStopPropagation [innerHTML]='[field.columnType === "DATE" ? (data[propertyName] | date : "dd/MM/yyyy") : data[propertyName]] '></td>
              </ng-container>
            </ng-container>
          </ng-container>
          <td *ngFor="let value of inputParams.customfieldValues;" clickStopPropagation (click)="OnClick(value.fieldData, data[RefId], data)"><b *ngIf="!value.isIcon">{{ value.translationKey | translate}}</b><i *ngIf="value.isIcon" [ngClass]="value.iconClass"></i></td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <hr />
  <div class="pager">
    <ul class="pagination">
      <li><strong><span>Showing Records<span>:</span></span></strong> {{showingRecordStart}} - {{showingRecordEnd}} of {{totalRows}}</li>
    </ul>

    <ul class="pagination">
      <li class="highlight"><a href="javascript:void(0);" (click)="switchPage(1)"><i class="fa fa-angle-double-left"></i></a></li>
      <li class="highlight"><a href="javascript:void(0);" (click)="switchPage(pageNo-1)"><i class="fa fa-angle-left"></i></a></li>
      <li><span>Page {{pageNo}} of {{totalPages}}</span></li>
      <li class="highlight"><a href="javascript:void(0);" (click)="switchPage(pageNo+1)"><i class="fa fa-angle-right"></i></a></li>
      <li class="highlight"><a href="javascript:void(0);" (click)="switchPage(totalPages)"><i class="fa fa-angle-double-right"></i></a></li>
      <li class="pagedropdown">
        <span class="goto">
          <span>Move To Page</span>:
          <select id="cmbpageno" (change)="selectPage($event);" [(ngModel)]="pageNo">
            <option *ngFor="let p of getTotalPagesList();" [value]="p">{{p}}</option>
          </select>
        </span>
      </li>
    </ul>
  </div>
</div>
